import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      width: '24rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '34rem',
    },
  },
  popupIndicatorOpen: {
    transform: 'unset',
  },
}));

// A server-driven suggestion box: options are never filtered client-side, and the search icon
// stands in for the popup arrow until something has been chosen.
const AppetiteAutocomplete = ({
  disableClearable = true,
  freeSolo = true,
  handleOnChange,
  handleOnInputChange,
  id,
  inputValue,
  invalidSearch,
  label,
  loading,
  options,
  placeholder,
  required,
  value,
  ...params
}) => {
  const classes = useStyles();

  return (
    <Autocomplete
      freeSolo={freeSolo}
      disableClearable={disableClearable}
      value={value}
      inputValue={inputValue}
      onChange={handleOnChange}
      onInputChange={handleOnInputChange}
      id={id}
      options={options ?? []}
      loading={loading}
      data-testid={id}
      filterOptions={(filtered) => filtered}
      popupIcon={!value?.length && <SearchIcon />}
      classes={{
        root: classes.root,
        popupIndicatorOpen: classes.popupIndicatorOpen,
      }}
      {...params}
      renderInput={(inputParams) => (
        <MuiTextField
          {...inputParams}
          error={!!invalidSearch}
          placeholder={placeholder}
          label={label}
          variant="outlined"
          helperText={invalidSearch}
          required={required}
          InputProps={{
            ...inputParams.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {inputParams.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

AppetiteAutocomplete.propTypes = {
  disableClearable: PropTypes.bool,
  freeSolo: PropTypes.bool,
  handleOnChange: PropTypes.func,
  handleOnInputChange: PropTypes.func,
  id: PropTypes.string,
  inputValue: PropTypes.string,
  invalidSearch: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default AppetiteAutocomplete;
